// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sw-1";
export var stateContainer = "_sw-0";